module.exports = __webpack_public_path__ + "img/gn.a2fa13aa.svg";